// extracted by mini-css-extract-plugin
export var blockedMessage = "_bn-3";
export var blockedOverlay = "_bn-1";
export var fadeIn = "_bn-2";
export var hereLink = "_bn-0";
export var slideUp = "_bn-4";